/** Extract Ticket Tailor ticket id from lanyard QR text (raw id or Connect scan URL). */
export function parseTicketId(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return "";

  try {
    const url = new URL(trimmed);
    const t = url.searchParams.get("t")?.trim();
    if (t) return t;
    const path = url.pathname.replace(/^\/+|\/+$/g, "");
    if (path && !path.includes("/")) return path;
  } catch {
    // not a URL — use raw value
  }
  return trimmed;
}